import type { createBrowserRouter } from 'react-router';

type ThemeRouter = Pick<
  ReturnType<typeof createBrowserRouter>,
  'state' | 'subscribe'
>;

export const getRouteTheme = (pathname: string) =>
  pathname === '/' ? 'light' : 'znario';

export const syncRouteTheme = (
  router: ThemeRouter,
  root: Pick<HTMLElement, 'setAttribute'> = document.documentElement
) => {
  const applyTheme = (pathname: string) => {
    root.setAttribute('data-theme', getRouteTheme(pathname));
  };

  applyTheme(router.state.location.pathname);
  return router.subscribe((state) => applyTheme(state.location.pathname));
};
